<template>

<DialogBox :settings="settings" @save="save" @show="showingDialog" @hide="hidingDialog">

    <v-menu right slot="header" offset-y >
        <template v-slot:activator="{ on }">
        <v-icon v-on="on">keyboard_arrow_down</v-icon>
        </template>
        <v-list>
            <v-list-item @click="debugRecord">
                <v-list-item-title>Debug Record</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
    <div style="position:relative" class="pr-4 pl-4 pb-4">   
        <ElementControl :element="page" />
    </div>
    <div slot="footer" class="dialog-footer">
        <DeleteButton v-if="true"  @delete="deleteButtonClicked"></DeleteButton>
    </div>
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'
import ElementControl from '@/screens/ElementControl'
import Firestore from '../data/Firestore'

import DeleteButton from '../ui-elements/DeleteButton'


import DialogBox from '../ui-elements/DialogBox'
import ContactHelpers from '../helpers/ContactHelpers'


export default {
props:{
    settings: Object,
    row: Object,
    fields: Array,
},
components:{
    DialogBox,
    DeleteButton,
    ElementControl,
},
data() {
    return {
        page: {
            type: 'Group',
        }
    }
},
computed: {
    pageDefinition() {
        let elements = []
        this.fields.forEach(field => {
            //const nameSlug = StringHelpers.toCamelCase(field.name)
            const element = Object.assign({}, field)
            delete element._id
            element.rowId = this.row._id
            element.fieldId = field._id
            element.value = this.row[element.identifier]
            element.data = this.row[`${element.identifier}Data`]
            element.name = element.identifier
            element.title = field.name
       
            elements.push(element)
        })
        return {
            title: null,
            type: 'Group',
            flat: true,
            hideIcons: true,
            hideTitle: true,
            elements: elements,
        } 
    }
   
},
methods: {

    debugRecord() {
        let path = `${this.row._path}/${this.row._id}`
        Firestore.openConsole(path)
    },

    newRowValues(previousRow, elements) {
        let newRow = {...previousRow}
        newRow._key = newRow._key || DataHelpers.getKey()
        elements.forEach(element => {
            if(typeof(element.value) !== 'undefined')
                newRow[element.name] = element.value
            if(typeof(element.data) !== 'undefined')
                newRow[`${element.name}Data`] = element.data
        })
        return newRow
    },

    save() {
        let newRow = this.newRowValues(this.row, this.page.elements)
        this.$emit('save', newRow)
        this.settings.visible = false
    },


    showingDialog() {
        this.page = this.pageDefinition

    },

    hidingDialog() {
        setTimeout( () => { 
            this.page = {type: 'Group'}
        }, 300)            
    },

    deleteButtonClicked() {
        this.$emit('delete', this.row)
        this.settings.visible = false
    }

},

created() {
    this.settings.height = '350px'
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// DataDialog.vue?7a785a6c